import '../CadastroMetas/CadastroMetas.css'

import Select from 'react-select';
import CustomMultiSelectGroup from '../CustomMultiSelectGroup/CustomMultiSelectGroup'
import { useEffect, useState } from 'react';
import { get, post } from '../../services/api';
import { logout } from '../../auth';
import { useNavigate } from 'react-router-dom';
import AdminSection from "../AdminSection/AdminSection";
import CustomMultiSelect from '../CustomMultiSelect/CustomMultiSelect';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content'

export default function MetaFlexivel({ setNotifier }) {
    const navigate = useNavigate();

    const TIPO_VENDEDOR = 2;

    const [ authTokenState, setAuthTokenState ] = useState(null);

    const mes_admissao = ['1º mês', '2º mês', '3º mês'];

    const mensagemNenhumaOpcaoAlternativa = () => 'Nenhuma opção disponível';

    const [ optionsTipos, setOptionsTipos ] = useState([]);
    const [ optionsAnimais, setOptionsAnimais ] = useState([]);
    const nomeMeses = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];
    const currentDate = new Date();
    function getMonth(monthIndex) {
        const accurateMonthIndex = monthIndex >= 0 ? monthIndex % 12 : 12 + monthIndex % 12
        return {
            label: nomeMeses[accurateMonthIndex],
            value: (accurateMonthIndex) + 1,
            ano: new Date().getFullYear() + Math.floor(monthIndex / 12)
        };
    };
    const optionsMes = [
        getMonth(currentDate.getMonth()),
        getMonth(currentDate.getMonth() + 1)
    ];

    const [ filiaisMetas, setFiliaisMetas ] = useState(undefined);

    const [ optionsCluster, setOptionsCluster ] = useState([]);
    const [ optionsRegiao, setOptionsRegiao ] = useState([]);
    const [ optionsFilial, setOptionsFilial ] = useState([]);

    const [ tipoSelecionado, setTipoSelecionado ] = useState(null);
    const [ animalSelecionado, setAnimalSelecionado ] = useState(null);
    const [ mesSelecionado, setMesSelecionado ] = useState(null);
    const [ anoSelecionado,setAnoSelecionado ] = useState(new Date().getFullYear());
    const [ filiaisSelecionadas, setFiliaisSelecionadas ] = useState(null);
    const [ clustersSelecionados, setClustersSelecionados ] = useState(null);
    const [ regioesSelecionadas, setRegioesSelecionadas ] = useState(null);
    const [ metasInputs, setMetasInputs ] = useState(new Array(mes_admissao.length).fill(''));

    const [ tipoOrigemCopia, setTipoOrigemCopia ] = useState(0)

    const selectStyle = { 
        control: (base, state) => ({
            ...base,
            background: "unset",
            borderColor: "#DCDCDC",
            borderRadius: "4px"
        }),
        menuPortal: base => ({ ...base, zIndex: 9999 }) 
    }

    async function setOptionsTiposWithRequest(authToken) {
        try {
            const tipos = await get('/admin/metas/tipo', null, authToken);
            const options = tipos
                .filter(tipo => tipo.id_tipo_metas === TIPO_VENDEDOR)
                .map(tipo => ({
                    label: tipo.descricao,
                    value: tipo.id_tipo_metas
                }));
    
            setOptionsTipos(options);
    
            setTipoSelecionado(options.find(option => option.value === TIPO_VENDEDOR));
    
            return tipos;
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }
    async function setOptionsAnimaisWithRequest(authToken) {
        try {
            const animais = await get('/admin/metas/animal', null, authToken);
            
            const limitedAnimais = animais.slice(0, 6);
    
            setOptionsAnimais(limitedAnimais.map(animal => ({
                label: animal.nome,
                value: animal.id_animal,
                id_tipo_metas: animal.id_tipo_metas,
                tipo_percentual: animal.tipo_percentual,
                meta_base: animal.meta_base
            })));
    
            return limitedAnimais;
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }
    async function setOptionsClusterWithRequest(authToken) {
        try {
            const clusters = await get('/admin/metas/cluster', null, authToken)
            setOptionsCluster(clusters.map(cluster => ({ 
                label: cluster.cluster, 
                value: cluster.id_cluster 
            })))

            return clusters
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }
    async function setOptionsRegiaoWithRequest(authToken) {
        try {
            const regioes = await get('/admin/metas/regiao', null, authToken)
            setOptionsRegiao(regioes.map(regiao => ({ 
                label: regiao.nome_regiao, 
                value: regiao.id_regiao 
            })))

            return regioes
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }
    async function setOptionsFilialWithRequest(authToken) {
        try {
            const filiais = await get('admin/metas/filial', null, authToken)
            setOptionsFilial(filiais)

            return filiais
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    const isSecondStageDisabled = (
            filiais=filiaisSelecionadas,
            mes=mesSelecionado, 
            ano=anoSelecionado, 
            animal=animalSelecionado, 
            clusters=clustersSelecionados, 
            regioes=regioesSelecionadas
        ) => (
        animal == null || 
        mes == null ||
        ano == null ||
        ((clusters == null || clusters?.length == 0) &&
        (regioes == null || regioes?.length == 0) &&
        (filiais == null || filiais?.length == 0))
    )

    function isSecondStagePopuled() {
        const metasNumber = metasInputs.map(metas => metas === '' ? NaN : Number(metas.replaceAll('.', '').replace(',', '.')))

        return metasNumber.every(metas => !isNaN(metas) && metas >= 0)
    }

    const todasFiliasDesabilitadas = typeof filiaisMetas !== 'undefined' && filiaisMetas.length !== 0 && filiaisMetas.filter(filial => filial.desabilitada).length === filiaisMetas[0].filiais_consultadas;

    function handleInputsChange(index, value, inputsState, setInputsState) {
        const values = [...inputsState] 
        values[index] = value 
        setInputsState(values) 
    };

    function refreshInputs(type = 'all') {
        switch(type) {
            case 'all':
                setAnimalSelecionado(null)
                setMesSelecionado(null)
                setAnoSelecionado(new Date().getFullYear())

                setClustersSelecionados(null)
                setRegioesSelecionadas(null)
                setFiliaisSelecionadas([])
            case 'valores':
                setTipoOrigemCopia(0)
                setMetasInputs(new Array(mes_admissao.length).fill(''))
                setFiliaisMetas([])
        }
    }
    
    function parseObjectToURLQuery(object) {
        return Object.keys(object).reduce(
            (accumulator, paramKey) => {
                if(object[paramKey]){
                    if(typeof object[paramKey] === 'object'){
                        return accumulator + object[paramKey].reduce((accumulator2, value) => accumulator2 + `&${paramKey}=${value}` , '')
                    }
                    else return accumulator + `&${paramKey}=${object[paramKey]}`
                }
                    
                else return accumulator
            }, '')
    }
    
    async function  setMetasWithRequest(filtros) {
        try {
            const metas = await get(`/admin/metas/getmetasflexiveis?${parseObjectToURLQuery(filtros)}`, null, authTokenState)

            if(metas) {
                const metasArray = Object.keys(metas).sort((a, b) => a - b).map(key => parseFloat(metas[key][0]));

                setMetasInputs(metasArray.map(meta => meta.toLocaleString('pt', { 
                    minimumFractionDigits: 0, 
                    maximumFractionDigits: 2 
                })));
    
                return metas;
            } else {
                return null;
            }
           
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }
    
    function getMetas(clustersSelecionados, regioesSelecionadas, filiaisSelecionadas, mesSelecionado, anoSelecionado, animalSelecionado) {
        refreshInputs('valores')
        if(!isSecondStageDisabled(filiaisSelecionadas, mesSelecionado, anoSelecionado, animalSelecionado, clustersSelecionados, regioesSelecionadas)){
            setMetasWithRequest({   
                id_clusters: clustersSelecionados,
                id_regioes: regioesSelecionadas,
                idfiliais: filiaisSelecionadas,

                id_animal: animalSelecionado.value,
                mes: mesSelecionado, 
                ano: anoSelecionado
            });
        }
    }

    function handleRefresh(e, type = 'all') {
        e.preventDefault()

        refreshInputs(type)
    }

    function formatarValoresFilial(valores) {
        if(Array.isArray(valores)){
            const filiais = optionsFilial
                                    .map(option => option.items)
                                    .flat()
                                    .map(filial => filial.value);
            
            const values = valores
                                .map(v => Number(v) + 10000)
                                .filter(v => !isNaN(v))
                                .filter(v => filiais.includes(v));
            
            return values;
        }
        return [];
    }

    useEffect(() => {
        const authToken = localStorage.getItem("adminToken");

        if(authToken == null) {
            logout();
            navigate("/login");
            return;
        }

        setAuthTokenState(authToken);
        setOptionsTiposWithRequest(authToken);
        setOptionsAnimaisWithRequest(authToken);
        setOptionsClusterWithRequest(authToken);
        setOptionsRegiaoWithRequest(authToken);
        setOptionsFilialWithRequest(authToken);
    }, [])
    
    function formatValue(input, type) {
        let formattedValue = input.value;

        if (tipoOrigemCopia !== 0) return formattedValue;
    
        if (type === 'meta') {
            formattedValue = formattedValue.replace(/[^\d,]/g, '');
            formattedValue = formattedValue.replace(/(?<!\d),/g, '');
            const firstCommaIndex = formattedValue.indexOf(',');
            formattedValue = formattedValue.replace(/,/g, (match, offset) => {
                return offset === firstCommaIndex ? match : '';
            });
    
            let numericValue = parseFloat(formattedValue.replace(',', '.'));
            numericValue = Math.min(Math.max(numericValue, 0), 100);
    
            if (isNaN(numericValue)) {
                formattedValue = '';
            } else {
                formattedValue = numericValue.toLocaleString('pt', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
            }
        } 
    
        return formattedValue;
    }
    async function handleMetasSubmit(event){
        event.preventDefault()

        const idUsuarioAtual = localStorage.getItem("idusuario")
        const authToken = localStorage.getItem("adminToken")

        if(typeof idUsuarioAtual === 'undefined') {
            logout()
        } else{
            /**Validações manuais*/
            if(clustersSelecionados == null && regioesSelecionadas == null && filiaisSelecionadas == null){
                setNotifier(false, "Nenhuma localidade escolhida!")
                return
            }
            /** */


            let valores = mes_admissao.map((mesAdmissao) => {
                let mesNumber = parseInt(mesAdmissao.replace(/[^\d]/g, ''));
            
                return { 
                    mes_admissao: mesNumber, 
                    meta: 0 
                };
            });
            if(tipoOrigemCopia === 0){
                valores = mes_admissao.map((mesAdmissao, index) => {
                    let mesNumber = parseInt(mesAdmissao.replace(/[^\d]/g, ''));
                    
                    return { 
                        mes_admissao: mesNumber, 
                        meta: Number(metasInputs[index].replaceAll('.', '').replace(',', '.'))
                    };
                });

            
                if(valores.find(valor => valor.meta === 0)){
                    const confirmarMetasZeradas = await withReactContent(Swal).fire({
                        title: <i>Atenção!</i>,
                        html: 'Existem valores zerados no cadastro. Deseja prosseguir?',
                        showCancelButton: true,
                        confirmButtonText: 'Sim',
                        cancelButtonText: 'Não',
                        confirmButtonColor: "green",
                    })
    
                    if(!confirmarMetasZeradas.isConfirmed){
                        return;
                    }
                }
            }

            const requisicao = {
                id_clusters: clustersSelecionados,
                id_regioes: regioesSelecionadas,
                idfiliais: filiaisSelecionadas,

                id_tipo_metas: tipoSelecionado.value,
                id_animal: animalSelecionado.value,
                mes: mesSelecionado.value,
                ano: anoSelecionado,
                idusuario: idUsuarioAtual,

                valores: valores,

                tipo_metas_copiar: tipoOrigemCopia
            }

            const { response } = await post('/admin/metas/flexivel', requisicao, authToken);

            if(response?.status === 500){
                setNotifier(false, response.data.Error)
            }
            else{
                setNotifier(true, 'Metas alteradas com sucesso')
                refreshInputs()
            }
        }
    }

    return <>
        <AdminSection
            etapa={1} titulo={'Selecione os filtros'} 
        >
            <div className='animal-first-values'>
                <div className='first-values-left'>
                    <div className='id_tipo_metas-wrapper'>
                        <label htmlFor="id_tipo_metas">Selecione o tipo</label>
                        <Select
                            name="id_tipo_metas"
                            className="react-select"
                            classNamePrefix="react-select"
                            value={tipoSelecionado}
                            onChange={(tipo) => { 
                                setTipoSelecionado(tipo) 

                                setAnimalSelecionado(null)
                            }}
                            options={optionsTipos}
                            placeholder="Tipo"
                            required
                            isSearchable={false}
                            noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                        />
                    </div>

                    <div className='id_animal-wrapper'>
                        <label htmlFor="id_animal">Selecione o animal</label>
                        <Select
                            name="id_animal"
                            className="react-select"
                            classNamePrefix="react-select"
                            value={animalSelecionado}
                            onChange={(animal) => { 
                                setAnimalSelecionado(animal) 

                                getMetas(clustersSelecionados, regioesSelecionadas, filiaisSelecionadas, mesSelecionado?.value, anoSelecionado, animal)
                            }}
                            options={optionsAnimais.filter(option => option.id_tipo_metas === tipoSelecionado?.value)}
                            placeholder="Animal"
                            required
                            isSearchable={false}
                            noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                        />
                    </div>

                    <div className='mes-wrapper'>
                        <label htmlFor="mes">Selecione o período</label>
                        <Select
                            name="mes"
                            className="react-select"
                            classNamePrefix="react-select"
                            options={optionsMes}
                            value={mesSelecionado}
                            onChange={mes => { 
                                setMesSelecionado(mes)
                                setAnoSelecionado(mes.ano) 

                                getMetas(clustersSelecionados, regioesSelecionadas, filiaisSelecionadas, mes.value, mes.ano, animalSelecionado)
                            }}
                            placeholder="Mês"
                            required
                            menuPortalTarget={document.body} 
                            styles={selectStyle}
                            isSearchable={false}
                            noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                        />
                    </div>

                    <div className='ano-wrapper'>
                        <input 
                            type='text' 
                            name='ano'
                            placeholder='Ano' 
                            value={anoSelecionado}
                            onChange={(value) => setAnoSelecionado(value.currentTarget.value)}
                            required
                            readOnly
                        />
                    </div>
                </div>
                <div className='first-values-right'>
                    <div className='id_cluster-wrapper'>
                        <label htmlFor="id_cluster">Selecione o cluster</label>
                        <CustomMultiSelect
                            selectedOptions={clustersSelecionados}
                            setSelectedOptions={setClustersSelecionados}
                            filteredOptions={optionsCluster}
                            placeholder={'Cluster'}
                            disabled={
                                (regioesSelecionadas != null && regioesSelecionadas?.length > 0) || 
                                (filiaisSelecionadas != null && filiaisSelecionadas?.length > 0)
                            }
                            onChange={(clusters) => getMetas(clusters, regioesSelecionadas, filiaisSelecionadas, mesSelecionado?.value, anoSelecionado, animalSelecionado)}
                        />
                    </div>

                    <span>ou</span>

                    <div className='id_regiao-wrapper'>
                        <label htmlFor="id_regiao">Selecione a região</label>
                        <CustomMultiSelect
                            selectedOptions={regioesSelecionadas}
                            setSelectedOptions={setRegioesSelecionadas}
                            filteredOptions={optionsRegiao}
                            placeholder='Região'
                            disabled={
                                (clustersSelecionados != null && clustersSelecionados?.length > 0) || 
                                (filiaisSelecionadas != null && filiaisSelecionadas?.length > 0) 
                            }
                            onChange={(regioes) => getMetas(clustersSelecionados, regioes, filiaisSelecionadas, mesSelecionado?.value, anoSelecionado, animalSelecionado)}
                        />
                    </div>

                    <span>ou</span>

                    <div className='idfiliais-wrapper'>
                        <label htmlFor="idfiliais">Selecione as filiais</label>
                        <CustomMultiSelectGroup
                            options={optionsFilial}
                            placeholder="Filiais"
                            selectedOptions={filiaisSelecionadas}
                            setSelectedOptions={setFiliaisSelecionadas}
                            className='input-idfiliais'
                            disabled={
                                (clustersSelecionados != null && clustersSelecionados?.length > 0) || 
                                (regioesSelecionadas != null && regioesSelecionadas?.length > 0)
                            }
                            doOnChange={(filiais) => getMetas(clustersSelecionados, regioesSelecionadas, filiais, mesSelecionado?.value, anoSelecionado, animalSelecionado)}
                            formatValuesOnFill={formatarValoresFilial}
                        />
                    </div>
                </div>
            </div>     
        </AdminSection>
        <AdminSection
            etapa={2} titulo={'Cadastrar Metas Flexíveis'}
            disabled={isSecondStageDisabled()}
        >
            
            <form className='form-gerencia-animal' onSubmit={handleMetasSubmit}>
                <div className='gerencia-animal-second'>
                    <div className='body'>
                        {mes_admissao.map((mesAdmissao, index) => (
                            <div key={mesAdmissao} className={`gerencia-animal-meta nivel-${mesAdmissao}`}>
                                <h2 style={{textAlign: "center"}}>{mesAdmissao}</h2>
                                <div>
                                    <div className='meta-wrapper'>
                                        <label htmlFor="meta">% Meta:</label>
                                        <input type="text" value={metasInputs[index] || ''} required
                                        onChange={(event) => {
                                            const value = formatValue(event.target, 'meta')
                                            handleInputsChange(index, value, metasInputs, setMetasInputs)
                                        }} disabled={tipoOrigemCopia !== 0}/>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className='animal-metas-buttons'>
                        <button className='animal-refresh-btn' 
                        disabled={isSecondStageDisabled() || 
                            !isSecondStagePopuled() ||
                            todasFiliasDesabilitadas
                        }
                        onClick={(e) => handleRefresh(e)}>Cancelar
                        </button>

                        <button className='animal-save-btn' 
                            disabled={isSecondStageDisabled() || 
                                !isSecondStagePopuled() ||
                                todasFiliasDesabilitadas
                            }
                        >Salvar
                        </button>
                    </div>
                </div>
            </form>
        </AdminSection>
    </>
}
